import Encrypt from 'jsencrypt/bin/jsencrypt.min.js'

export const DecryptRSA = (privateKey, encryptedValue) => {
    if (encryptedValue.length > 0) {
        // Decrypt with the private key...
        var decrypt = new Encrypt();
        decrypt.setPrivateKey(privateKey);
        var uncrypted = decrypt.decrypt(encryptedValue);
        return uncrypted;
        //alert(uncrypted)
    }
    else {
        //alert("Something went wrong!")
        return null
    }
};